import { TFunction } from "i18next";
import { z } from "zod";

export const getMonitoringRecordFormSchema = (t: TFunction) => {
  return z.object({
    variableId : z
      .number({
        required_error: t("captures.capture.monitoring.errors.variable-required"),
        invalid_type_error: t("captures.capture.monitoring.errors.variable-required"),
      }),
    measuredAt: z.string().nullable().optional(),
    value: z
      .number({
        required_error: t("captures.capture.monitoring.errors.value-required"),
        invalid_type_error: t("captures.capture.monitoring.errors.value-required"),
      }),
    flag: z.string().nullable().optional(),
    notes: z.string().nullable().optional(),  
    });
};

export type MonitoringRecordForm = z.infer<ReturnType<typeof getMonitoringRecordFormSchema>>;